import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import instance from "../../api/api";
import { ProfilHeader } from "../Profil";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { Header,LoadingSpinner } from "../../shared/compoments";


export const PermissionsComp = ({ dataPermission }) => {
  return (
    <>
      <h5 className="fw-bold">Permissions</h5>
      <Stack
        direction="row"
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "1.5em",
          flexWrap: "wrap",
        }}
      >
        {dataPermission.length > 0 ?
          dataPermission.map((item) => (
            <Button
              variant="contained"
              sx={{
                background: "#2E22A6",
                color: "white",
                borderRadius: "5px",
              }}
              key={item.id}
            >
              {item.libelle}
            </Button>
          )):<h6 className="text-secondary">Pas de permissions</h6>}
      </Stack>
    </>
  );
};

function DetailPersonnels() {
  const { id } = useParams();
  const [detailPersonnel, setDetailPersonnel] = useState(null);
  useEffect(() => {
    const getDetailPersonnel = async () => {
      try {
        const response = await instance.get(`/users/${id}`);
        console.log("getDetailPersonnel", response);
        setDetailPersonnel(response.data.data);
      } catch (error) {
        console.error("Une erreur s'est produite : ", error);
      }
    };
    getDetailPersonnel();
  }, [id]);

  if (!detailPersonnel)
    return (
      <LoadingSpinner />
    );
  return (
    <>
      {detailPersonnel && (
        <div>
          <Header libelle={"Détails personnel"} isReturn />
          <br />
          <ProfilHeader
            namePerson={`${detailPersonnel.prenom} ${detailPersonnel.nom}`}
            rolePerson={detailPersonnel.role.libelle}
            detailUserInfo={true}
            detailPhone={detailPersonnel.phone}
            detailAdresse={detailPersonnel.adresse}
            detailEmail={detailPersonnel.email}
          />
          <div className="conteneur-info p-5">
            <PermissionsComp dataPermission={detailPersonnel?.permissions} />
          </div>
        </div>
      )}
    </>
  );
}

export default DetailPersonnels;
